module.exports = __webpack_public_path__ + "img/slider_3.9e97b0dd.jpg";